import React, { useState, useEffect } from "react";
import "./style.css";
import API from "../../utils/API";
import cogoToast from "@successtar/cogo-toast";
import UploadDocWidget from "../UploadDocWidget";

function DocVault({ docIDArray, rootPolicyID, rootPolicyType, closeModal }) {
  const [formData, setFormData] = useState({
    policyID: "",
    policyType: "",
    fileArray: [],
    vaultDocIDs: []
  });

  useEffect(() => {
    console.log("Doc Vault Mounted");
    console.log(docIDArray);
    API.getDocumentsByIdArray(docIDArray)
      .then((res) => {
        console.log("Found Documents");
        setFormData((prev) => ({
          ...prev,
          fileArray: res.data,
          policyID: rootPolicyID,
          policyType: rootPolicyType,
          vaultDocIDs: docIDArray
        }));
      })
      .catch((err) => {
        console.log("Error, could not obtain documents");
        console.log(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refreshDocuments = (newDocID) => {
    console.log(newDocID);
    console.log(formData.vaultDocIDs);
    const vaultDocIDsUpdated = formData.vaultDocIDs.slice(0);
    vaultDocIDsUpdated.push(newDocID);
    setFormData((prev) => ({
      ...prev,
      vaultDocIDs: vaultDocIDsUpdated
    }));

    API.getDocumentsByIdArray(vaultDocIDsUpdated)
      .then((res) => {
        console.log("Found Documents");
        setFormData((prev) => ({
          ...prev,
          fileArray: res.data,
          policyID: rootPolicyID,
          policyType: rootPolicyType
        }));
      })
      .catch((err) => {
        console.log("Error, could not obtain documents");
        console.log(err);
      });
  };

  const downloadBase64File = (e, base64Data, docName) => {
    e.preventDefault();
    const linkSource = base64Data;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = docName;
    downloadLink.click();
    cogoToast.info("Document downloading...");
  };

  return (
    <div>
      <div style={{ textAlign: "center", backgroundColor: "whitesmoke" }}>
        <div style={{ float: "right" }}>
          <button className="btn btn-secondary" onClick={(e) => closeModal(e)}>
            X
          </button>
        </div>
        <br />
        <h3 style={{ marginTop: "25px" }}>Document Vault</h3>
        <hr />
        <div>
          <div className="row">
            {formData.fileArray.map((file) => (
              <div className="col-lg-4" style={{ padding: "15px" }} key={file._id}>
                <p>{file.docName}</p>

                {file.docName.split(".")[1] === "pdf" ? (
                  <i
                    className="hoverhand fa fa-file-pdf-o fa-3x"
                    onClick={(e) => downloadBase64File(e, file.document, file.docName)}
                    aria-hidden="true"
                  ></i>
                ) : (
                  <i
                    className="hoverhand fa fa-file-code-o fa-3x"
                    onClick={(e) => downloadBase64File(e, file.document, file.docName)}
                    aria-hidden="true"
                  ></i>
                )}
                <br />
                <button
                  style={{ border: "0px" }}
                  className="btn btn-primary"
                  onClick={(e) => downloadBase64File(e, file.document, file.docName)}
                >
                  Download
                </button>
              </div>
            ))}
          </div>
          <br />
          <br />
          <div className="row" style={{ position: "absolute", bottom: "0", width: "100%" }}>
            <div className="col">
              <UploadDocWidget
                id={formData.policyID}
                policyType={formData.policyType}
                refreshVault={refreshDocuments}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DocVault;
